export default "__VITE_ASSET__7Y7yct3$__"